// Imports => React
import { useState, useMemo } from 'react';
import {withStore} from '@stores';
import {observer} from 'mobx-react-lite';
import clsx from 'clsx';

// Imports => Constants
import {KEYS, THEMES, TYPES} from '@opp/ui-kit';

// Imports => Utilities
import {AcIsSet} from '@opp/ui-kit';

// Imports => Atoms
import {
  AcContainer,
  AcRow,
  AcColumn,
  AcRichContent,
  AcButton,
  AcLoaderInline,
} from '@opp/ui-kit';
import {withTranslation} from "react-i18next";

const _CLASSES = {
  MAIN: 'ac-confirmation-modal ac-modal--size-sm',
  CONTENT: 'ac-confirmation-modal__content',
};

const AcConfirmationModal = ({
  store: {ui},
  instance = {
    is_busy: false,
  },
  content,
  cancel = {
    label: null,
    callback: () => {
    },
  },
  confirm = {
    label: null,
    callback: () => {
    },
  },
  t
}) => {

  const [isLoading, setIsLoading] = useState(false);

  const handleCancel = async (event) => {
    if (event && event.preventDefault) {
      event.preventDefault();
    }
    if (cancel && cancel.callback) {
      await cancel.callback();
    }
    await ui.reset(KEYS.CONFIRM_MODAL);
  };

  const handleConfirm = async (event) => {
    if (event && event.preventDefault) {
      event.preventDefault();
    }
    if (event && event.persist) {
      event.persist();
    }

    setIsLoading(true);

    if (confirm && confirm.callback) {
      await confirm
        .callback()
        .then(() => {
          if (close) {
            ui.setValue(KEYS.CONFIRM_MODAL, KEYS.VISIBLE, false);
          }
          setIsLoading(false);
        })
        .catch(() => {
          if (close) {
            ui.setValue(KEYS.CONFIRM_MODAL, KEYS.VISIBLE, false);
          }
          setIsLoading(false);
        });
    }
  };

  const getCancelButtonOptions = useMemo(() => {
    if (!cancel) {
      return {};
    }

    return {
      type: TYPES.BUTTON,
      theme: THEMES.LIGHT,
      title: cancel.label || t('cancel', {ns: 'common'}),
      callback: handleCancel,
    };
  }, [cancel, t]);

  const getConfirmButtonOptions = useMemo(() => {
    return {
      type: TYPES.BUTTON,
      theme: THEMES.OMEGA,
      title: confirm.label || t('confirm', {ns: 'common'}),
      loading: isLoading,
      callback: handleConfirm,
    };
  }, [confirm, isLoading]);

  const renderContent = useMemo(() => {
    if (!AcIsSet(content)) {
      return null;
    }

    return (
      <AcRow className={'h-margin-y-40'}>
        <AcColumn>
          <AcRichContent content={content} />
        </AcColumn>
      </AcRow>
    );
  }, [content]);

  const getContentClassNames = useMemo(() => {
    return clsx([_CLASSES.CONTENT]);
  }, []);

  const getStyleClassNames = useMemo(() => {
    return clsx([_CLASSES.MAIN]);
  }, []);

  return (
    <div className={getStyleClassNames}>
      <div className={getContentClassNames}>
        <AcContainer fluid>
          {content && renderContent}

          {isLoading && <AcLoaderInline loading dense />}

          <AcRow className={'h-margin-top-40'}>
            {cancel && (
              <AcColumn
                xs={7}
                sm={6}
                className={'h-text--align-left h-flex-v-align-center'}
              >
                <AcButton {...getCancelButtonOptions}>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: cancel && cancel.label,
                    }}
                  />
                </AcButton>
              </AcColumn>
            )}

            <AcColumn
              xs={cancel ? 5 : 12}
              sm={cancel ? 6 : 12}
              className={
                cancel ? 'h-text--align-right' : 'h-text--align-center'
              }
            >
              {confirm && (
                <AcButton {...getConfirmButtonOptions}>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: confirm && confirm.label,
                    }}
                  />
                </AcButton>
              )}
            </AcColumn>
          </AcRow>

        </AcContainer>
      </div>
    </div>
  );
};

export default withTranslation(['common'])(withStore(observer(AcConfirmationModal)));
